export let isProgramManager;

export let socialAdvocacy;

export function setSocialAdvocacy(SocialAdvocacy) {
    isProgramManager = SocialAdvocacy.isProgramManager;
    socialAdvocacy = SocialAdvocacy;
}
